import React from 'react'
import Grid from "@material-ui/core/Grid";
import Navigation from './Navigation';
import { withStyles } from "@material-ui/core/styles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import deepPurple from '@material-ui/core/colors/deepPurple';

const defaultTheme = createMuiTheme({ 

  palette: {
    primary: {

      light: grey[100],
      main: grey[300],
      dark: grey[500]

    },
    secondary: deepPurple,
    error: red,
    custom: {
      back: "#fafafa",
      nav: "#651fff",
      headerBack: "#2b313c",
      dark: "#424549",
      darker: "	#1e2124"
    },
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: 3,
    // Used to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  /*
  palette: {
    primary: {
      light: grey[100],
      main: grey[300],
      dark: grey[500],

    },
    secondary: {
      light: "#a255ff",
      main: "#651fff",
      dark: "#3400a7",
    },
    alternate: {
      light: "#ffc947",
      main: "#ff9800",
      dark: "#c66900",
    }

  },*/
  typography: {
    useNextVariants: true,
    /*fontFamily: 

      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),*/
      
  },

})

const { breakpoints, typography: { pxToRem } } = defaultTheme

const theme = {
...defaultTheme,
overrides: {
  MuiTypography: {
    h1: {
      fontSize: "7rem",
      [breakpoints.down("sm")]: {
        fontSize: "6rem"
      },
      [breakpoints.down("xs")]: {
        fontSize: "3rem"
      },

    }
  }
}
}

const Layout = props =>  {

  const { classes } = props;

  return (

    <MuiThemeProvider theme={theme}>
      
      <CssBaseline />

        <Grid container direction="column" className={classes.layout} >

          <Grid item xs={12}>
            <Navigation/>
          </Grid>

          <Grid item className={classes.body} xs={12}>
            {props.children}
          </Grid>

        </Grid>

    </MuiThemeProvider>
  );

};






const styles = theme => ({
  layout: {
    minHeight: "100vh",
    backgroundColor: theme.palette.primary.back,
    overflowX: 'hidden',
    
  },

  body: {
    
    marginBottom: theme.spacing.unit * 5,
    paddingBottom: theme.spacing.unit * 5,
    height: '100%'
    //minHeight: "calc(100vh - 141px)", //size of navbar and footer added

  }

});

export default withStyles(styles)(Layout)
